if (!customElements.get('runor-pack-sticky')) {
  customElements.define('runor-pack-sticky', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.bar=this.querySelector('[data-pack-sticky-bar]');
      this.target=document.getElementById(this.dataset.target);
      this.submit=document.getElementById(this.dataset.submit);
      if (!this.bar || !this.target || !this.submit) return;
      this.controller=new AbortController();
      document.body.append(this.bar);
      const schedule=()=>{if (!this.frame) this.frame=requestAnimationFrame(()=>{this.frame=null;this.update();});};
      window.addEventListener('scroll',schedule,{passive:true,signal:this.controller.signal});
      window.addEventListener('resize',schedule,{passive:true,signal:this.controller.signal});
      document.addEventListener('runor:pack-added',schedule,{signal:this.controller.signal});
      this.bar.querySelector('a').addEventListener('click',event=>{
        event.preventDefault();
        this.bar.hidden=true;
        const heading=this.target.querySelector('.rnp-heading');
        heading?.setAttribute('tabindex','-1');
        heading?.focus({preventScroll:true});
        this.target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
      },{signal:this.controller.signal});
      this.resizeObserver=new ResizeObserver(schedule);
      this.resizeObserver.observe(this.target);
      this.resizeObserver.observe(this.submit);
      this.drawerObserver=new MutationObserver(schedule);
      const drawer=document.querySelector('cart-drawer');
      if (drawer) this.drawerObserver.observe(drawer,{attributes:true,attributeFilter:['class','open']});
      this.update();
    }
    update() {
      if (!this.submit?.isConnected || !this.bar) return;
      const pastButton=this.submit.getBoundingClientRect().bottom<=0;
      const cartOpen=Boolean(document.querySelector('cart-drawer.active, cart-drawer[open]'));
      this.bar.hidden=!(pastButton && !cartOpen && this.submit.getClientRects().length);
    }
    disconnectedCallback() {
      this.controller?.abort();this.controller=null;
      this.resizeObserver?.disconnect();this.drawerObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame=null;
      if (this.bar) {this.bar.hidden=true;this.append(this.bar);}
    }
  });
}
